import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import "../instances/connect/products/style.css";
import ProductSearchPopup from "./ProductSearchPopup"; // Import the popup component
import { useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

function ProductSearch() {
  // Separate state for queries based on search type
  const [queries, setQueries] = useState({ id: "", normal: "", asiLive: "" });
  const [searchType, setSearchType] = useState("asi-live-id"); // Default is "id"
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  let { instanceUniqueId } = useParams();
  const [showRateLimitMessage, setShowRateLimitMessage] = useState(false);
  // State to store the latest diagnostic message (response data or error)
  const [diagnosticMessage, setDiagnosticMessage] = useState("");

  const handleSearch = async (page = 1) => {
    const currentQuery = queries[searchType];
    let urlToSendTo;

    // For ASI ID searches, use the popup
    if (searchType === "id") {
      urlToSendTo = "https://server.elitecore.ca/products/get-live-product";
      setLoading(true);
      setTimeout(() => {
        openPopup({ Id: currentQuery });
        setLoading(false);
      }, 1000);
      return;
    } else if (searchType === "asi-live-id") {
      urlToSendTo = "https://server.elitecore.ca/products/get-asi-live-product";
      setLoading(true);
      setTimeout(() => {
        openPopup({ Id: currentQuery });
        setLoading(false);
      }, 1000);
      return;
    }
    // For normal (keyword) search, use the get-live-products endpoint without the popup
    else if (searchType === "normal") {
      urlToSendTo = "https://server.elitecore.ca/products/get-live-products";
    }

    // Perform the normal search
    setLoading(true);
    let timer;
    if (loading) {
      timer = setTimeout(() => {
        setShowRateLimitMessage(true);
      }, 7000);
    }
    try {
      const response = await axios.get(urlToSendTo, {
        params: {
          q: currentQuery,
          page: page,
          rpp: 99,
          sort: "DFLT",
        },
      });
      setProducts(response.data.Results || []);
      setTotalPages(response.data.TotalPages || 1);
      setCurrentPage(page);
      setError("");
      setDiagnosticMessage(JSON.stringify(response.data, null, 2));
      return () => clearTimeout(timer);
    } catch (error) {
      alert(error);
      const errorMsg = "An error occurred while fetching products. " + error;
      setError(errorMsg);
      setDiagnosticMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handleSearch(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handleSearch(currentPage - 1);
    }
  };

  const openPopup = (product) => {
    setSelectedProduct(product);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedProduct(null);
  };

  const handleCopyDiagnostic = () => {
    if (diagnosticMessage) {
      navigator.clipboard.writeText(diagnosticMessage)
        .then(() => {
          toast.success("Diagnostic message copied to clipboard!");
        })
        .catch(() => {
          toast.error("Failed to copy diagnostic message.");
        });
    } else {
      toast("No diagnostic message available.");
    }
  };

  return (
  <>
    <div className="instance-dashboard">
      <div className="rightSide place-items-top">
        <>
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
              <div className="product-container">
                <strong>Please note, product search now requires logging in and has been moved to: <a className="login-link" href="https://app.elitecore.ca/instance/elite-promo-marketing/connect/products">https://app.elitecore.ca/instance/elite-promo-marketing/connect/products</a></strong>
                <hr></hr>
                <div><b>Email:</b> <span>demouser@elitepromomarketing.com</span></div>
                <div><b>Password:</b> <span>Elite$999!@ </span></div>
                <div><b>Login link:</b> <a className="login-link" href="https://app.elitecore.ca/login/" target="_blank">https://app.elitecore.ca/login/</a></div>
                <i>If you encounter server errors when logging in, please use an incognito window or clear your device's cookies.</i>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>




      {/*<div className="rightSide place-items-top">
        <>
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
              <div className="product-container">
                <div className="product-search-container search-container">
                  <input
                    type="text"
                    value={queries[searchType]}
                    onChange={(e) =>
                      setQueries({ ...queries, [searchType]: e.target.value })
                    }
                    placeholder="Enter search term..."
                  />
                  <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                  >
                    <option value="asi-live-id">ASI Id</option>
                    <option value="id">ASI Id (New)</option>
                    <option value="normal">Keyword search</option>
                  </select>
                  <a
                    onClick={() =>
                      queries[searchType] ? handleSearch(1) : null
                    }
                    className={!queries[searchType] ? "disabled" : ""}
                  >
                    Search
                  </a>
                </div>

                {error && <p>{error}</p>}
                {products.length > 0 && searchType === "normal" ? (
                  <>
                    <div className="info-note">
                      <p className="search-filter-example-heading">
                        <SearchIcon /> Search filter examples:
                      </p>
                      <p className="search-filter-example-list">
                        {searchType === "id" ? (
                          <>
                            <b>ID:</b> Please input IDs directly (e.g., 554276215, 552204918)
                          </>
                        ) : searchType === "asi-live-id" ? (
                          <>
                            <b>ASI Live ID:</b> Please input IDs directly (e.g., 554276215, 552204918)
                          </>
                        ) : (
                          <>
                            <b>Keyword search:</b> Please input any product keyword (e.g., hat, shirt, supplier product codes)
                          </>
                        )}
                      </p>
                    </div>

                    <div className="product-grid">
                      {products.map((product) => (
                        <div
                          key={product.Id}
                          className="product-item"
                          onClick={() => openPopup(product)}
                        >
                          <img
                            src={`https://api.asicentral.com/v1/${product.ImageUrl}?size=normal`}
                            alt={product.Name}
                          />
                          <h3>{product.Name}</h3>
                          <p>{product.ShortDescription}</p>
                          <p>
                            <strong>Price:</strong> ${product.Price.Price}
                          </p>
                          <p>
                            <strong>ASI ID:</strong> {product.Id}
                          </p>
                          <p>
                            <strong>Number:</strong> {product.Number}
                          </p>
                          <p>
                            <strong>Supplier:</strong> {product.Supplier.Name}
                          </p>
                          <p>
                            <strong>Colors:</strong>{" "}
                            {Array.isArray(product.Colors)
                              ? product.Colors.join(", ")
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Sizes:</strong>{" "}
                            {Array.isArray(product.Sizes)
                              ? product.Sizes.join(", ")
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Materials:</strong>{" "}
                            {Array.isArray(product.Materials)
                              ? product.Materials.join(", ")
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Production Time:</strong>{" "}
                            {product.ProductionTimes && product.ProductionTimes[0]
                              ? `${product.ProductionTimes[0]} days`
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Stock Status:</strong>{" "}
                            {product.HasInventory ? "In Stock" : "Low Stock"}
                          </p>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <p className="search-filter-example-list">
                      {searchType === "id" || searchType === "asi-live-id" ? (
                        <>
                          <b>ID:</b> Please input IDs directly (e.g., 553129378, 552204918)
                        </>
                      ) : (
                        <>
                          <b>Keyword search:</b> Please input any product keyword (e.g., hat, shirt, supplier product codes)
                        </>
                      )}
                    </p>
                  </>
                )}

                {searchType !== "id" || searchType !== "asi-live-id" ? (
                  <div className="pagination-controls">
                    <button
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

          </div>

          {loading ? (
            <div className="page-loading-in-progress">
              <p>Looking up {queries[searchType]}...</p>
            </div>
          ) : (
            <>
{ ( (searchType === "id" || searchType === "asi-live-id") && isPopupOpen ) && (
  <ProductSearchPopup
    isOpen={isPopupOpen}
    onRequestClose={closePopup}
    productId={selectedProduct ? selectedProduct.Id : null}
    instanceUniqueId={instanceUniqueId}
    searchType={searchType}
  />
)}

            </>
          )}
        </>


</div>*/}




    </>
  );
}

export default ProductSearch;
